//  points
//  👉 if you give just 'primary' anywhere, by default primary.main will be considered - that is our standard purple color, primary.main from primary object in palette below  ( same for secondary - secondary.main)

//  👉 for backgrounds for basic boxes and grids - give property like
// <Grid bgColor={theme.palette.background.light}> ..... </Grid> - this will give background of white in light mode and light black-greyish color in dark mode because see in background object in palette object below --- search for `theme.palette.background' in the src folder to see examples

// 👉 for texts - on dark backgrounds - we want white text and on white / light backgrounds we want black text - for this use `theme.palette.text.primary` ( see text object in the palette below ) -- search for `theme.palette.text.primary` in src folder to see examples

// 👉 for header navbar - give - style={{ backgroundColor: theme.palette.background.main }} commonpageheading

// 🌟 if you ever get stuck - search for 'theme.palette' in the src folder to see how I have used this feature throughout the app

// color design tokens export
export const colorTokens = {
	grey: {
		0: '#FFFFFF',
		10: '#F4F7FC', // bg color
		50: '#F0F0F0',
		100: '#E0E0E0',
		110: '#dadada',
		200: '#C2C2C2',
		300: '#A3A3A3',
		400: '#858585',
		500: '#666666',
		600: '#4D4D4D',
		650: '#2f2f2f', // dropdowns list bg color and calender bg color in dark
		700: '#24282F', // grid  boxes / cards / filter modal  background
		750: '#0000001a', // dark grey
		800: '#161B22', // changed - dark
		900: '#0D1116', // changed default page background
		950: '#060F1D', // header navbar changed
		1000: '#000000',
	},
	primary: {
		50: '#E6FBFF',
		100: '#f9f7fc',
		200: '#F2E9FF',
		300: '#a45cffbd',
		400: '#D412FF',
		500: '#9149ff',
		600: '#00A0BC',
		700: '#006B7D',
		800: '#00353F',
		900: '#001519',
	},
	others: {
		// define additional colors here and define in palette for both dark and light theme - eg check / search for - channelAndAttributeBoxesStyle
		// also see this link for examples - https://stackblitz.com/edit/react-4b6dzp?file=MyTheme.js,index.js
		10: '#00A0BC',
	},
};

// mui theme settings
export const themeSettings: any = (mode: string) => {
	return {
		palette: {
			mode: mode,
			...(mode === 'dark'
				? {
						// palette values for dark mode
						primary: {
							dark: colorTokens.primary[400],
							main: colorTokens.primary[500],
							light: colorTokens.primary[800],
						},
						secondary: {
							dark: colorTokens.grey[400],
							main: colorTokens.grey[100],
							light: colorTokens.primary[800],
						},
						info: {
							dark: colorTokens.primary[400],
							main: colorTokens.grey[200],
							light: colorTokens.primary[800],
						},
						neutral: {
							dark: colorTokens.grey[950],
							// main: colorTokens.grey[500],
							main: colorTokens.grey[650],
							mediumMain: colorTokens.grey[300],
							medium: colorTokens.grey[400],
							light: colorTokens.grey[700],
						},
						background: {
							default: colorTokens.grey[900], // default black  - not exactly black
							alt: colorTokens.grey[800], // greyish black for grids / boxes
							main: colorTokens.grey[950], //  dark color
							mediumMain: colorTokens.grey[650],
							light: colorTokens.grey[700], // light greyish - graphs / cards bg
							dark: colorTokens.grey[1000], // pure black color
						},
						text: {
							primary: colorTokens.grey[0],
							// secondary: colorTokens.grey[0],
						},
						// main app colors
						outerAppStyle: {
							backgroundColor: colorTokens.grey[950],
						},
						dashboardRedBoxStyle: {
							color: '#cf1408',
						},
						dashboardGreenBoxStyle: {
							color: '#1ba150',
						},
						// for calender in filters reports -:
						reactDateTimePickerStyle: {
							backgroundColor: colorTokens.grey[950],
							color: colorTokens.grey[0],
						},
						// in governance -:
						channelAndAttributeBoxesStyle: {
							backgroundColor: colorTokens.grey[800],
							color: colorTokens.grey[0],
							borderBottom: `1px solid ${colorTokens.grey[650]} `,
						},
						// in crm configuration - pink boxes in stepper
						configurationPinkBoxStyle: {
							backgroundColor: 'inherit',
							color: colorTokens.grey[1000],
						},
						// rules box - background
						ruleBoxStyle: {
							backgroundColor: 'inherit',
						},
						// filter calender style in dark mode
						reactFilterCalenderStyle: {
							backgroundColor: colorTokens.grey[800],
							color: colorTokens.grey[0],
							border: `1px solid ${colorTokens.primary[500]}`,
						},
						// common page heading style - navbar
						commonPageHeadingNavbarStyle: {
							backgroundColor: colorTokens.grey[800],
							borderBottom: `1px solid ${colorTokens.grey[650]}`,
							boxShadow: 'none',
						},
						// custom waterfall in channel manager -{}
						customWaterfallColors: {
							defaultChannelsDot: {
								backgroundColor: colorTokens.others[10],
							},
						},
				  }
				: {
						// *palette values for light mode
						primary: {
							dark: colorTokens.primary[400],
							main: colorTokens.primary[500],
							light: colorTokens.primary[50],
						},
						secondary: {
							dark: colorTokens.grey[400],
							main: colorTokens.primary[500],
							light: colorTokens.primary[800],
						},
						info: {
							dark: colorTokens.primary[400],
							main: colorTokens.grey[500],
							light: colorTokens.primary[800],
						},
						neutral: {
							dark: colorTokens.grey[0],
							main: colorTokens.grey[750],
							mediumMain: colorTokens.grey[400],
							medium: colorTokens.grey[300],
							light: colorTokens.grey[50],
						},
						background: {
							default: colorTokens.grey[10],
							alt: colorTokens.grey[0],
							main: colorTokens.grey[0],
							mediumMain: colorTokens.grey[110],
							light: colorTokens.grey[0],
							dark: colorTokens.grey[0], // pure white color
						},
						text: {
							primary: colorTokens.grey[1000],
							secondary: colorTokens.grey[800],
						},
						// main app colors
						outerAppStyle: {
							backgroundColor: colorTokens.grey[10],
						},
						dashboardRedBoxStyle: {
							color: '#cf1408',
						},
						dashboardGreenBoxStyle: {
							color: '#2a8063',
						},
						// for calender in filters reports -:
						reactDateTimePickerStyle: {
							backgroundColor: colorTokens.grey[0],
							color: colorTokens.grey[950],
						},
						// in governance - :
						channelAndAttributeBoxesStyle: {
							backgroundColor: colorTokens.primary[200],
							color: colorTokens.grey[1000],
							borderBottom: `solid 0.4px #eeeded`,
						},
						// in crm configuration - pink boxes in stepper
						configurationPinkBoxStyle: {
							backgroundColor: colorTokens.primary[100],
							color: colorTokens.grey[1000],
						},
						ruleBoxStyle: {
							backgroundColor: colorTokens.primary[100],
						},
						// filter calender style in light mode
						reactFilterCalenderStyle: {
							backgroundColor: colorTokens.grey[0],
							color: colorTokens.grey[1000],
							// border: `1px solid ${colorTokens.primary[500]}`
						},
						// common page heading style - navbar in light mode
						commonPageHeadingNavbarStyle: {
							backgroundColor: colorTokens.grey[0],
							borderBottom: `none`,
							boxShadow: `rgb(100 100 111 / 20%) 0px 7px 10px 0px`,
						},
						// custom waterfall in channel manager -{}
						customWaterfallColors: {
							defaultChannelsDot: {
								backgroundColor: colorTokens.others[10],
							},
						},
				  }),
		},
		typography: {
			h6: {
				fontSize: '18px',
				'@media (max-width:1500px)': {
					fontSize: '1rem',
				},
				'@media (max-width:1366px)': {
					fontSize: '0.9rem',
				},
			},
			h5: {
				fontSize: '22px',
				fontWeight: 600,
				'@media (max-width:1500px)': {
					fontSize: '20px',
				},
				'@media (max-width:1366px)': {
					fontSize: '1rem',
				},
			},
			h4: {
				fontSize: '28px',
				fontWeight: 600,
				'@media (max-width:1500px)': {
					fontSize: '24px',
				},
				'@media (max-width:1366px)': {
					fontSize: '20px',
				},
			},
			h3: {
				fontSize: '2rem',
				fontWeight: 600,
				'@media (max-width:1500px)': {
					fontSize: '1.6rem',
				},
				'@media (max-width:1366px)': {
					fontSize: '1.4rem',
				},
			},
			h2: {
				fontSize: '45px',
				'@media (max-width:1500px)': {
					fontSize: '2.8rem',
				},
				'@media (max-width:1366px)': {
					fontSize: '2.4rem',
				},
			},
			h1: {
				fontSize: '68px',
				'@media (max-width:1500px)': {
					fontSize: '4rem',
				},
				'@media (max-width:1366px)': {
					fontSize: '3.4rem',
				},
			},
			fontFamily: 'Lato',
		},
	};
};
